export default function MetricBadge({ children, tone = 'info' }) {
  return <span className={'shared-metric-badge is-' + tone}>{children}</span>;
}
